<template>
  <div class="listmain ">
    <h1 class="firTitle">智能家居技能发布流程</h1>
	  <span>
<p>
	<span class="ql-author-7802039 ql-size-9">本文档旨在教您快速创建一个智能家居技能技能,智能家居技能帮助三方开发者接入受控设备,实现受控设备智能化</span>
</p>
<p>
	<br />
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">1.登录OrionOS开放平台</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">使用OrionOS开放平台的功能,需要</span>先注册OrionOS开发者账号<span class="ql-author-7802039 ql-size-9">.如需发布上线,请登录账号后完成</span>开发者认证<span class="ql-author-7802039 ql-size-9">.</span>
</p>
<p>
	<br />
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">2.智能家居技能协议文档</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">在创建技能之前,您需要了解智能家居技能的协议文档, 请参照</span>智能家居协议文档
</p>
<p>
	<br />
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">3.创建智能家居技能</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能是用户进行语音交互的基本单位.</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">登录OrionOS开放平台后,在导航栏点击"控制台",在技能列表中,点击"+创建技能", 选择“智能家居”技能,填写技能基本资料.</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能类型:默认自定义类型</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能名称:技能展示到技能商店的名称,不可重复</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能标识:技能的唯一调用标识,不可重复.</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能分类:合理定义技能类别有利于用户和开发者方便找到技能,提升技能曝光率</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能图标:展示到技能商店的LOGO,是技能的图形品牌形象</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">技能介绍:对技能进行简要介绍,便于用户更直观的了解技能的使用场景和用处</span>
</p>
<p>
	<br />
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">4.配置服务</strong>
</p>
<p>
	OrionOS服务采用WebService进行部署,且不限制部署环境,开发者可以自行进行选择托管于公有云或自行部署。开发者最终需要提供用户技能服务的处理网关,OrionOS会将所有的请求转发到该网关。
</p>
<p>
	部署完毕,当前端用户使用语音进入开发者的技能后,后端服务会将该语音链路请求转换为语音链路描述转发到配置的技能网关
</p>
<img src="../../../../static/images/smartHomeImg/server2.png" alt="配置服务">
<p>
	<strong class="ql-author-7802039 ql-size-9">Oauth授权信息配置</strong>
</p>
<p>
	采用通用的OAuth2.0开放授权协议,可以让OrionOS在不获取合作方用户名和密码的前提下,访问用户授权的资源,协议规范及授权流程请参照：智能家居授权流程介绍
</p>
<p>
	开发者需填写字段解释：
</p>
<p>
	esponseType: code
</p>
<p>
	ClientID: 用户注册应用时获得的API Key
</p>
<p>
	ClientSecret: 填写用户请求密钥
</p>
<p>
	授权地址: 表示该链接为开发商提供的账户授权登录的H5页面链接
</p>
<p>
	回调地址:授权回调OrionOS的回调地址（服务端提供,不可修改）
</p>
<p>
	Token地址: 通过该token进行访问合作方的服务（版本更新后,新生成的token地址将自动覆盖线上token,开发者测试时,需要更新设备信息）
</p>
<p>
	Scope权限: 开发者可访问的内容权限,空格分隔
</p>
<p>
	<br />
</p>
<p>
	开发者填写完配置信息后,点击授权按钮,跳转到Oauth授权页面,开发者完成授权后,即可对受控设备进行在线测试控制。
</p>
<p>
	<span class="ql-author-7802039"> </span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">5.在线测试</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">开发者可以通过在线测试,对受控设备进行测试,如"打开卧室的灯". </span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">如果设备信息发生变更,需要开发者手动获取最新设备信息,如需更新设备信息,点击在线测试中“更新云端设备信息”即可。</span>
</p>
</span>
	  <img src="../../../../static/images/smartHomeImg/test2.png" alt="在线测试">
	  <span>
<p>
	<strong class="ql-author-7802039 ql-size-9">6.技能发布</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">当技能构建完成,同时测试通过后,可以通过技能发布,让市场中的用户使用. 技能发布后除非撤销审核将不可编辑. 技能审核通过后, 将发布到技能商店后,所有开发者均可使用该技能.</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">如果希望该技能仅供自己使用,可以选择发布到我的技能,再智能硬件控制台-技能配置-我的技能中可查看发布后的技能。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">发布上线后,如需更新技能,可以再技能版本管理中,更新当前技能。</span>
</p>
</span>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 30px;
      font-size: 16px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
      width: 100%;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/Zn_jnfblc.vue